import { render, staticRenderFns } from "./DeviceWindow2.vue?vue&type=template&id=7fefefb5&scoped=true"
import script from "./DeviceWindow2.vue?vue&type=script&lang=js"
export * from "./DeviceWindow2.vue?vue&type=script&lang=js"
import style0 from "./DeviceWindow2.vue?vue&type=style&index=0&id=7fefefb5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fefefb5",
  null
  
)

export default component.exports